import React from 'react'
import ForgotPassword from "../../Components/UserComponents/ForgotPassword.jsx";

const CollaborateurForgotPasswordPage = () => {
  return (
    <div><ForgotPassword type={"collaborateur"}/></div>
  )
}

export default CollaborateurForgotPasswordPage